<template>
  <div>
    <div v-if="showImage" class="camera-modal">
      <video ref="video" class="camera-stream"/>
    </div>
    <div>
      <VueSignaturePad id="signature" width="300px" height="250x" ref="signaturePad" :options="{onBegin, onEnd}"/>
    </div>
    <b-alert v-if="error" variant="danger" show>{{ error }}</b-alert>
    <b-button-group style="width: 100%">
      <b-button variant="warning" @click="doClear()">Clear</b-button>
      <b-button variant="info" @click="doSign()" :disabled="btnSignDisabled">Sign</b-button>
    </b-button-group>

    <!-- Dialog Ok -->
    <b-modal id="signOk" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="d-block text-center">
        <h4>Document signed successfully!</h4>
      </div>
      <b-button class="mt-3" block @click="closeAndRedirect()">Close</b-button>
    </b-modal>

    <!-- Dialog No Sign -->
    <b-modal id="noSign" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="d-block text-center">
        <h4>There is no signature</h4>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('noSign')">Close</b-button>
    </b-modal>
  </div>
</template>

<script>
import * as Sentry from '@sentry/browser';
import moment from 'moment';
import okm from '../api';

export default {
    name: 'Signature',
    data() {
      return {
        btnSignDisabled: false,
        mediaStream: null,
        showImage: false,
        error: null
      }
    },
    methods: {
      doClear() {
        this.$refs.signaturePad.clearSignature();

        if (this.$store.state.cameraEnabled) {
          this.destroyCamera();
        }
      },
      doSign() {
        const {isEmpty, data} = this.$refs.signaturePad.saveSignature();
        const stampIdProperty = 'doc-signer.stamp.id';
        this.btnSignDisabled = true;
        this.error = null;

        if (!isEmpty) {
          if (this.$store.state.curDoc) {
            okm.getConfiguration(stampIdProperty).then(res => {
              console.log("getConfiguration:", res.data);

              if (res.data.value) {
                const ratio = Math.max(window.devicePixelRatio || 1, 1);
                const docUuid = this.$store.state.curDoc.uuid;
                const stampId = res.data.value;

                // console.log("docUuid:", docUuid);
                // console.log("stampId", stampId);
                // console.log("ratio:", ratio);
                // console.log("data:", data);

                okm.stampDocument(docUuid, stampId, data, ratio).then(res => {
                  console.log("stampDocument", res.data);

                  if (this.$store.state.locationEnabled) {
                    this.sendLocation(docUuid);
                  }

                  if (this.$store.state.cameraEnabled) {
                    this.takePicture(docUuid);
                  }
                  this.$bvModal.show('signOk');
                }).catch(err => {
                  this.showError(err);
                });
              } else {
                this.error = 'Missing "' + stampIdProperty + '" configuration property';
              }
            }).catch(err => {
              this.showError(err);
            });
          } else {
            this.showError("Missing document");
          }
        } else {
          this.$bvModal.show('noSign');
        }

        this.btnSignDisabled = false;
      },
      closeAndRedirect() {
        this.$bvModal.hide('signOk');
        this.$router.push('documents');
      },
      initializeCamera() {
        console.log("initializeCamera");
        if (navigator.mediaDevices) {
          navigator.mediaDevices.getUserMedia({video: true})
            .then(mediaStream => {
              console.log("mediaStream", mediaStream);
              this.mediaStream = mediaStream;
              this.$refs.video.srcObject = mediaStream;
              this.$refs.video.play();
            })
            .catch(err => {
              this.showError(err);
            })
        } else {
          this.showError("No media devices available");
        }
      },
      destroyCamera() {
        console.log("destroyCamera");
        const tracks = this.mediaStream.getTracks();
        tracks.map(track => track.stop());
        this.showImage = false;
      },
      takePicture() {
        console.log("takePicture");
        const mediaStreamTrack = this.mediaStream.getVideoTracks()[0];
        const imageCapture = new window.ImageCapture(mediaStreamTrack);
        imageCapture.takePhoto().then(blob => {
          this.destroyCamera();

          const parent = this.$store.state.curDoc.parent;
          const name = this.$store.state.curDoc.uuid + ".png";
          okm.createDocument(parent, name, blob).then(res => {
            console.log("createDocumentResult", res.data);
          }).catch(err => {
            this.showError(err);
          });
        });
      },
      sendLocation(docUuid) {
        console.log("sendLocation", docUuid);

        if (this.$store.state.location) {
          const grpName = "okg:doc_signer";
          okm.hasGroup(docUuid, grpName).then(res => {
            console.log("hasGroup:", res.data);
            if (!res.data) {
              const props = [
                { name: 'okp:doc_signer.latitude', value: this.$store.state.location.latitude },
                { name: 'okp:doc_signer.longitude', value: this.$store.state.location.longitude},
                { name: 'okp:doc_signer.time', value: moment(new Date()).format('YYYYMMDDHHmmss') }
              ];

              okm.addGroup(docUuid, grpName, props).then(res => {
                console.log("addGroup", res.data);
              }).catch(err => {
                this.showError(err);
              });
            }
          }).catch(err => {
            this.showError(err);
          });
        } else {
          console.log("Sorry, no location available");
        }
      },
      onBegin() {
        // console.log("onBegin");
        // https://medium.com/theodo/a-progressive-web-application-with-vue-js-webpack-material-design-part-4-96c8c216810b
        if (this.$store.state.cameraEnabled) {
          if (!this.showImage) {
            this.showImage = true;
            this.initializeCamera();
          }
        }
      },
      onEnd() {
        // console.log("onEnd");
        // window.clearInterval(this.interval);
      },
      showError(err) {
        Sentry.captureException(err);
        this.error = err;
      }
    }
  }
</script>

<style scoped>
  #signature {
    background-color: aliceblue;
    border: solid 3px;
    border-radius: 5px;
    height: 150px;
    margin: auto;
  }

  .camera-modal {
    width: 100%;
    height: 50%;
    top: 60px;
    left: 0;
    position: absolute;
    background-color: white;
    z-index: 10;
  }

  .camera-stream {
    width: 100%;
    max-height: 100%;
  }
</style>
